import { graphql } from "gatsby"
import React from "react"
import { Layout, Head as HeadComponent } from "@bw/layouts"
import { PageHeader } from "@bw/modules"
import { Avatar, CmsImage } from "@bw/bits"
import dateFormat from "../utils/dateFormat"
import { Content } from "@bw/modules/mapModules"
import { useBreadcrumbs } from "../hooks/useBreadcrumbs"

export const Head = ({ location, pageContext, data }) => {
  return (
    <HeadComponent
      title={data.page.metaTitle || data.page.title}
      image={
        data.page.image?.localImage?.childImageSharp?.original?.src ??
        data.page.teaserImage?.localImage?.childImageSharp?.original?.src
      }
      data={data}
      location={location}
      pageContext={pageContext}
      description={data.page.metaDescription}
      doNotIndex={data.page.doNotIndex}
    />
  )
}

const ArticleTemplate = ({ data, pageContext, location }) => {
  const { page, parents, mount } = data

  const breadcrumbsLinks = useBreadcrumbs({
    mount,
    page,
    parents: pageContext.parents.map(id =>
      parents.nodes.find(parent => parent.id === id)
    ),
  })

  return (
    <Layout {...{ pageContext, location }}>
      <PageHeader
        suptitle={
          page.date ? dateFormat(page.date, pageContext.locale) : undefined
        }
        title={page.title}
        breadcrumbs={breadcrumbsLinks}
        subtitle={page.authors.map((author, i) => (
          <Avatar
            key={i}
            image={
              author.avatar?.url ? (
                <CmsImage src={author.avatar?.url} alt="" />
              ) : undefined
            }
            name={author.name}
          />
        ))}
      />
      <Content modules={page.content} />
    </Layout>
  )
}

export default ArticleTemplate

export const articleQuery = graphql`
  query articleQuery($id: String!, $parents: [String]) {
    parents: allCollectionPages(filter: { id: { in: $parents } }) {
      nodes {
        id
        to: slug
        title
      }
    }

    page: collectionArticles(id: { eq: $id }) {
      url
      title
      metaTitle
      metaDescription
      date
      locale
      image {
        localImage {
          childImageSharp {
            original {
              src
            }
          }
        }
      }
      doNotIndex
      teaserExcerpt

      teaserImage {
        localImage {
          childImageSharp {
            original {
              src
            }
          }
        }
      }

      authors {
        name
        avatar {
          url
        }
      }

      content {
        __typename
        suptitle
        title
        subtitle
        backgroundVariant
        buttonType {
          value
        }
        buttonUrl
        buttonIsExternal
        buttonOpenInModal
        buttonText
        buttonPosition {
          value
        }
        buttonEntry {
          url
        }
        idAttribute
        classAttribute

        ...AudioModuleFragment
        ...CallToActionModuleFragment
        ...ContentModuleFragment
        ...ContentWithImageModuleFragment
        ...GalleryModuleFragment
        ...ContentOnColumnsModuleFragment
        ...DownloadsModuleFragment
        ...TeasersManualModuleFragment
        ...LogoGridModuleFragment
        ...ImageModuleFragment
        ...VideoModuleFragment
        ...FormModuleFragment
        ...ListOfPoisModuleFragment
        ...ListOfArticlesModuleFragment
        ...ListOfProfilesModuleFragment
        ...ListOfJobsModuleFragment
        ...ListOfEventsModuleFragment
        ...LinksModuleFragment
        ...PredefinedModuleModuleFragment
      }
    }

    mount: collectionPages(mount: { handle: { eq: "articles" } }) {
      slug
      title
    }
  }
`
